import classNames from "classnames";
import style from "./AppSearchFilters.module.scss";
import colourStyle from "../SearchResults/EnhancedSearchResults.module.scss";
import PropTypes from "prop-types";

const AppGuidelineItem = ({
  guideline,
  resultCount,
  selectedGuideline,
  updateSelected,
}) => {
  let iconClassName = guideline.replace(/ /g, "").toLowerCase();

  const selectGuideline = (event) => {
    if (selectedGuideline.includes(event.target.value)) {
      updateSelected(
        selectedGuideline.filter(
          (currentGuideline) => currentGuideline !== guideline,
        ),
      );
    } else {
      updateSelected(selectedGuideline.concat([event.target.value]));
    }
  };

  return (
    <li className={style.guidelineListItem}>
      <label className={classNames(style.guidelineContainer)}>
        <div
          className={classNames(
            colourStyle[iconClassName],
            style.guidelineIcon,
          )}
        />
        <div
          className="size-14 medium"
          data-testid="guidelineTitle"
        >{`${guideline} (${resultCount})`}</div>
        <div className={style.counter}>
          <input
            type="checkbox"
            id={guideline}
            name="guideline"
            value={guideline}
            checked={selectedGuideline.includes(guideline)}
            onChange={selectGuideline}
            className={style.customCheckbox}
          />
        </div>
      </label>
    </li>
  );
};

AppGuidelineItem.propTypes = {
  guideline: PropTypes.string.isRequired,
  resultCount: PropTypes.number.isRequired,
  selectedGuideline: PropTypes.arrayOf(PropTypes.string).isRequired,
  updateSelected: PropTypes.func.isRequired,
};

export default AppGuidelineItem;
